import { CountryState } from '../../interfaces/location';
import { FetchCountriesAction } from '../actions/country.action';
import { ActionType } from '../action_types';

const initialState: CountryState = {
  countries: [],
};

const countriesReudcer = (state = initialState, action: FetchCountriesAction): CountryState => {
  switch (action.type) {
    case ActionType.FETCH_COUNTRIES:
      return { ...state, countries: action.payload.countries };
    default:
      return { ...state };
  }
};

export default countriesReudcer;
